class MobileNavPanels extends HTMLElement {
  constructor() {
    super()
    this.stack = ['root']
    this.panels = {}
    this.refreshPanels()
    this.addEventListener('click', this.onClick.bind(this))

    this.drawer = this.closest('.f-drawer-mobile-nav')
    if (this.drawer) {
      this.drawer.addEventListener('close', this.reset.bind(this))
    }
  }

  refreshPanels() {
    this.panels = {}
    this.querySelectorAll('.f-mobile-nav__panel').forEach((panel) => {
      this.panels[panel.dataset.panelId] = panel
    })
    this.updatePanels()
  }

  reset() {
    this.stack = ['root']
    this.updatePanels()
  }

  onClick(event) {
    const openTrigger = event.target.closest('[data-open-panel]')
    if (openTrigger) {
      const id = openTrigger.getAttribute('data-open-panel')
      if (this.panels[id]) {
        event.preventDefault()
        this.stack.push(id)
        this.updatePanels()
      }
      return
    }

    const closeTrigger = event.target.closest('[data-close-panel]')
    if (closeTrigger && this.stack.length > 1) {
      event.preventDefault()
      this.stack.pop()
      this.updatePanels()
    }
  }

  updatePanels() {
    const activeId = this.stack[this.stack.length - 1]
    const prevId = this.stack.length > 1 ? this.stack[this.stack.length - 2] : null

    Object.keys(this.panels).forEach((id) => {
      const panel = this.panels[id]
      panel.classList.remove('is-active', 'is-prev')

      if (id === activeId) {
        panel.classList.add('is-active')
        panel.setAttribute('aria-hidden', 'false')
        panel.scrollTop = 0
      } else if (id === prevId) {
        panel.classList.add('is-prev')
        panel.setAttribute('aria-hidden', 'true')
      } else {
        panel.setAttribute('aria-hidden', 'true')
      }
    })
  }
}

if (!customElements.get('mobile-nav-panels')) {
  customElements.define('mobile-nav-panels', MobileNavPanels)
}
